import styled from "styled-components";

export const Wrapper = styled.div`
    min-height: 100vh;
    position: relative;
    padding-bottom: 128px;
    box-sizing: border-box;
`

export const MainContents = styled.div`
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 960px;
`

export const Container = styled.div`
    margin: 0 16px 32px 16px;
`